<template>
  <div class="navBar-warp s-f-r s-a-c s-j-b">
    <div class="nav-left s-f-r s-a-c pl-4">
      <el-tooltip class="item" effect="dark" content="Expands/Contracts" placement="bottom">
        <i
          class="nav-left-item iconfont "
          :class="!collapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
          :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }"
          @click="handleCommand('collapse')"
        />
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="Reload The Current Tab" placement="bottom">
        <i
          class="nav-left-item iconfont icon-refresh-right"
          :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }"
          @click="handleCommand('refresh-tab')"
        />
      </el-tooltip>
      <div style="margin-left: 50px">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item
            v-if="breadcrumbList && breadcrumbList.length > 0"
            :to="{ path: '/' }"
          >Home</el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">{{ item }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="nav-right s-f-r s-a-c">
		
	  <div
		v-if="!$store.state.user.isDefault"
	    class="icon-btn-item"
	    :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }"
	    @click="Refreshpermission"
	  >
	    <i class="iconfont el-icon-refresh" />
	    <label>Refresh permission</label>
	  </div>
	  
      <div
		v-if="userInfo.isVip"
        class="icon-btn-item text-yellow-300"
        @click="$router.push({ path: '/function/vip' })"
      >
        <svg-icon class="font-bold" style="font-size: 22px; height: 1em; width: 1em;" icon-name="vip" icon-class="vip" />
        <span class="ml-2">Vip</span>
      </div>

      <el-popover v-model="noticeVisible" placement="bottom-end" width="300" trigger="hover">
        <div>
          <div v-if="noticeList && noticeList.length" class="border-b mb-3">
            <div
              v-for="(item, i) in noticeList"
              :key="i"
              class="my-3 cursor-pointer text-dark-800 hover:text-primary"
              @click="toNotice(item)"
            >
              <div class="text-cut ">{{ item.title }}</div>
              <div class="text-muted">{{ item.createTime }}</div>
            </div>
          </div>

          <div class="text-center">
            <el-link class="text-center !underline" href="/appvue/function/notificeList">See all notifications</el-link>
          </div>
        </div>

        <!-- <el-button >content</el-button> -->
        <div slot="reference" class="icon-btn-item" :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }">
          <i class="iconfont icon-remind" />
          <label>Notification</label>
        </div>
      </el-popover>

      <div
        class="icon-btn-item"
        :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }"
        @click="$router.replace('/function/helpeCenter')"
      >
        <i class="iconfont icon-help" />
        <label>Help Cente</label>
      </div>
      <div
        class="icon-btn-item"
        :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }"
        @click="handleCommand('setting')"
      >
        <i class="iconfont icon-set" />
        <label>Setting</label>
      </div>
      <!-- <i
        class="nav-right-item iconfont icon-color"
        :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }"
        @click="handleCommand('layout-set')"
      />
      <i
        class="nav-right-item iconfont"
        :class="fullScreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'"
        :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }"
        @click="handleFullScreen"
      />
      <el-avatar v-if="userInfo.avatar && userInfo.avatar.length > 6" :src="userInfo.avatar" :size="32" />
      <el-avatar v-else :size="32" icon="el-icon-user-solid" /> -->

      <div
        class="icon-btn-item"
        :style="{ color: theme.head === 0 ? '#4d5259' : '#ffffff' }"
        :class="{ '!text-yellow-300': userInfo.isVip }"
      >
        <svg-icon v-if="userInfo.isVip" class="mr-1" icon-class="VIP" style="font-size: 20px;" />
        <i v-else class="iconfont icon-bussiness-man" />
        {{ userInfo.name || account.userName }}
      </div>
    </div>
	
	
	
	<el-dialog 
	    :title="detailData.title" 
	    :visible.sync="detailVisible"
	    width="640px"
	    top="5vh"
	    class="detail-dialog"
		@close="readNotice(detailData.id)"
		:close-on-click-modal="false"
		:show-close="false"
	  >
		<div v-loading="isProcessing">
			<!-- 图片展示区域 -->
			<div class="image-gallery" v-if="imageList.length">
			    <!-- 主轮播 -->
			    <el-carousel 
			      :autoplay="false" 
			      :arrow="imageList.length == 1 ? 'never' : 'always'" 
			      indicator-position="none"
			      height="240px"
			      ref="mainCarousel"
			      @change="handleCarouselChange"
			    >
			      <el-carousel-item v-for="(img, index) in imageList" :key="index">
			        <el-image 
			          :src="img" 
			          fit="contain" 
			          class="main-image"
			          :preview-src-list="imageList"
			        >
			          <div slot="error" class="image-slot">
			            <i class="el-icon-picture-outline"></i>
			          </div>
			        </el-image>
			      </el-carousel-item>
			    </el-carousel>
			
			    <!-- 缩略图导航 -->
			    <div class="thumbnail-nav" v-if="imageList.length > 1">
			      <div
			        v-for="(img, index) in imageList"
			        :key="index"
			        class="thumbnail-item"
			        :class="{ 'active': activeIndex === index }"
			        @click="switchSlide(index)"
			      >
			        <el-image 
			          :src="img" 
			          fit="cover" 
			          class="thumbnail-image"
			        >
			          <div slot="error" class="thumbnail-slot">
			            <i class="el-icon-picture-outline"></i>
			          </div>
			        </el-image>
			      </div>
			    </div>
			  </div>
				
			<!-- 富文本内容 -->
			<div class="rich-text-content" v-if="detailData.richText">
			  <div v-html="detailData.richText"></div>
			</div>
				
			<!-- 附件下载区域 -->
			<div class="attachment-list" v-if="filesList.length">
			  <h4>Attachments：</h4>
			  <div class="file-list">
			    <div 
			      v-for="(file, index) in filesList" 
			      :key="index" 
			      class="file-item"
			    >
			      <el-link 
			        type="primary" 
			        :href="file.url" 
			        target="_blank" 
			        :download="file.name"
			      >
			        <i class="el-icon-document"></i>
			        {{ file.name }}
			      </el-link>
			    </div>
			  </div>
			</div>
		</div>
	    <template #footer>
		  <el-button v-if="isNext" :loading="isProcessing" type="primary" @click="NextNotice(detailData.id)">Next</el-button>
		  <el-button v-else :loading="isProcessing" @click="detailVisible = false">Close</el-button>
	    </template>
	  </el-dialog>
	  
	  
	  <el-dialog
		:title="orderDetali.type == 1 ? 'Inventory Order Arrived!' : 'Self-Purchase Inventory Order Arrived!'"
		:visible.sync="orderVisible"
		width="1200px"
		top="5vh"
		class="detail-dialog"
	  	@close="ReadPurchaseNotice(orderListIds[0])"
	  	:close-on-click-modal="false"
	  	:show-close="false"
		center
	    >
		<div style="font-size: 16px;color: #303133;">
			{{ orderDetali.type == 1 ? 'Inventory Order No.:' : 'Self-Purchase Inventory Order NO.:' }}{{ orderDetali.orderNo }}
			<el-tag v-if="orderDetali.isPendingStockIn">Still in Processing</el-tag>
		</div>
	  	<div v-loading="isProcessing">
			<el-table :data="[{}]" v-for="todo in orderDetali.items" :key="todo.id">
				<el-table-column label="Product" width="320">
					<template v-slot="{row}">
					  <div class="flex">
					    <img class="w-18 h-18" :src="joinHead(todo.skuImageUrl)" alt="">
					    <div class="flex-1 min-w-0 px-3">
						  <div class="text-cut h-5">
							  code: {{ todo.productCode }}
						  </div>
					      <div class="text-cut h-5">
					        {{ todo.productId }}
					      </div>
					      <div class="text-cut h-5">
					        <el-tooltip :content="todo.subjectEn " placement="top-end" effect="light">
					          <span>{{ todo.subjectEn }}</span>
					        </el-tooltip>
					      </div>
					      <div>{{ todo.attributes.map(attr => { return attr.attributeEnValue }).join(' / ') }}</div>
					    </div>
					  </div>
					</template>
				</el-table-column>
				<el-table-column v-for="(item, index) in todo.itmes" :key="todo.createTime" :label="(index + 1) +''" width="200" align="center">
					<template v-slot="{row}">
						<div style="text-align: center;">
							<div>{{ item.createTime }}</div>
							<div>{{ item.nums }} / {{ todo.nums }}</div>
							<el-tag size="small" effect="plain" type="danger" v-if="item.type == 2">Refund</el-tag>
							<el-tag size="small" effect="plain" type="success" v-else>Arrived</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="Purchase/Arrival/Refund" width="200" align="center">
					<template v-slot="{row}">
						{{ todo.nums }}/{{ todo.itmes.reduce((acc, { type, nums }) => type === 1 ? acc + nums : acc, 0) }}/{{ todo.refundNums }}
					</template>
				</el-table-column>
				<el-table-column label="Current Inventory Quantity" width="200" align="center">
					<template v-slot="{row}">
						{{ todo.currStockQuantity }}
					</template>
				</el-table-column>
			</el-table>
	  	</div>
	      <template #footer>
			<div style="display: flex;justify-content: flex-end;">
				<el-button v-if="isOrder" :loading="isProcessing" type="primary" @click="NextOrder(orderListIds[0])">Next</el-button>
				<el-button v-else :loading="isProcessing" @click="orderVisible = false">Close</el-button>
			</div>
	      </template>
	    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import store from '@/store'
import { GetUnreadNotice, getNotice, readNotice } from '@/api/notice/index'
import { GetNoReadNotice, GetNoReadNoticeInfo, ReadPurchaseNotice } from '@/api/purchase.js'
import screenfull from 'screenfull'
export default {
  name: 'ToolBar',
  props: ['collapse', 'breadcrumb'],
  data() {
    return {
		activeIndex: 0, // 当前激活的轮播索引
		detailVisible: false,
		detailData: {
			id: '',
			title: '',
			images: '',
			richText: '',
			files: ''
		},
      fullScreen: false,
      noticeList: [],
      noticeVisible: false,
	  isProcessing: false,
	  orderListIds: [],
	  orderDetali: '',
	  orderVisible: false
    }
  },
  computed: {
	isNext() {
		const arr = this.noticeList.filter((item) => { return item.id != this.detailData.id })
		if (arr.length) return arr[0]
		return false
	},
	isOrder() {
		if (this.orderListIds.length > 1) return this.orderListIds[1]
		return false
	},
	imageList() {
		return this.detailData.images ? this.detailData.images.split(',') : []
	},
	filesList() {
		return this.detailData.files ? JSON.parse(this.detailData.files) : []
	},
    breadcrumbList() {
      return this.breadcrumb.map((el) => {
        return el.title
      })
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      account: (state) => state.user.account
      // theme: (state) => state.settings.theme
    }),

    ...mapGetters(['theme'])
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown, true)
    if (screenfull.isEnabled) {
      screenfull.on('change', this.fullScreenChange)
    }

    this.getNoticeList()
  },
  beforeDestroy() {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.fullScreenChange)
    }
  },
  methods: {
	  handleCarouselChange(index) {
	        this.activeIndex = index
	      },
	      switchSlide(index) {
	        this.activeIndex = index
	        this.$refs.mainCarousel.setActiveItem(index)
	      },
	Refreshpermission() {
		store.dispatch('GetUserAuthoritys').finally(() => {
			store.dispatch('GenerateRoutes').then((res) => {
				if (store.state.user.menuIds.indexOf(this.$route.meta.tag) ==  -1) {
					if (res) {
						this.$router.replace('/')
					} else {
						this.$router.replace('/noRoute/index')
					}
				}
			})
		})
	},
    async getNoticeList() {
      const { data } = await GetUnreadNotice({
        pageNum: 1,
        pageSize: 100
        // readStatus: 0,
      })
      this.noticeList = data.result
	  if (this.noticeList.length > 0 && !this.$store.state.user.isAdmin) {
		  this.toNotice(this.noticeList[0])
	  }
	  GetNoReadNotice({ pageNum: 1, pageSize: 100 }).then((res) => {
	  	this.orderListIds = res.data
		if (this.noticeList.length == 0 && this.orderListIds.length > 0 && !this.$store.state.user.isAdmin) {
			this.toOrder(this.orderListIds[0])
		}
	  })
	  // setTimeout(() => {
	  // 	this.getNoticeList()
	  // }, 60000)
    },
	async NextNotice(id) {
		if (this.isProcessing) return
		this.isProcessing = true
		await this.readNotice(id)
		await this.toNotice(this.isNext)
		this.isProcessing = false
	},
	async NextOrder(id) {
		if (this.isProcessing) return
		this.isProcessing = true
		await this.ReadPurchaseNotice(id)
		await this.toOrder(this.orderListIds[0])
		this.isProcessing = false
	},
	async ReadPurchaseNotice(id) {
		if (!this.$store.state.user.isAdmin) await ReadPurchaseNotice({ id })
		const index = this.orderListIds.findIndex((item) => { return item == id })
		this.orderListIds.splice(index, 1)
	},
	async readNotice(id) {
		if (!this.$store.state.user.isAdmin) await readNotice(id)
		const index = this.noticeList.findIndex((item) => { return item.id == id })
		this.noticeList.splice(index, 1)
		if (this.noticeList.length == 0 && this.orderListIds.length > 0) this.toOrder(this.orderListIds[0])
	},
	async toOrder(id) {
		const res = await GetNoReadNoticeInfo({ id })
		res.data.items.forEach((item) => {
			if (item.itmes) {
				item.itmes = item.itmes.sort((a, b) => new Date(a.createTime) - new Date(b.createTime))
			} else {
				item.itmes = []
			}
		})
		this.orderDetali = res.data
		this.orderVisible = true
	},
    async toNotice(item) {
		const { data } = await getNotice(item.id)
		this.detailData = data
		this.detailVisible = true
		this.noticeVisible = false
    },
    handleCommand(command) {
      this.$emit('command', command)
    },
    handleFullScreen() {
      if (!screenfull.isEnabled) {
        this.$message.warning('您的浏览器不支持该功能！')
        return false
      }
      screenfull.toggle()
    },
    fullScreenChange() {
      // console.log('dawdwadwa')
      this.fullScreen = screenfull.isFullscreen
    },
    keyDown(e) {
      if (e.keyCode === 122) {
        e.returnValue = false
        this.handleFullScreen()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
	
	// .el-table th.el-table__cel// .el-table--enable-row-transition .el-table__body td

::v-deep .el-table__cell {
	border: 1px solid #dfe6ec;
}
	
.navBar-warp {
  height: 50px;
  padding: 0 20px 0 5px;

  .nav-left,
  .nav-right {
    &-item {
      font-size: 24px;
      margin: 0 10px;
      cursor: pointer;
      color: #555;
    }

    &-avatar {
      margin: 0 5px 0 20px;
    }

    &-dropdown {
      margin: 0 10px 0 5px;
      cursor: pointer;
    }

    .icon-btn-item {
      display: flex;
      align-items: center;
      margin-right: 24px;
      cursor: pointer;

      label {
        cursor: pointer;
        font-size: 14px;
        margin-left: 6px;
      }

      .iconfont {
        font-size: 24px !important;
      }
    }
  }
}
.detail-dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 30px;
	min-height: 70vh;
  }

  .image-gallery {
    position: relative;
    margin-bottom: 20px;
  
    .main-image {
      width: 100%;
      height: 240px;
      background: #f8f9fa;
      border-radius: 4px;
    }
  
    .thumbnail-nav {
	  position: absolute;
	  left: 50%;
	  bottom: -8px;
	  z-index: 100;
	  transform: translateX(-50%);
      display: flex;
      gap: 10px;
      padding: 15px 0;
      overflow-x: auto;
	  // opacity: 0.3;
	  &:hover {
		  // opacity: 1;
	  }
      .thumbnail-item {
        position: relative;
        flex-shrink: 0;
        width: 80px;
        height: 60px;
        border: 2px solid transparent;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
  
        &.active {
          border-color: #409EFF;
          transform: translateY(-3px);
        }
  
        &:hover:not(.active) {
          border-color: #c0c4cc;
        }
  
        .thumbnail-image {
          width: 100%;
          height: 100%;
          border-radius: 3px;
        }
      }
  
      /* 隐藏滚动条 */
      &::-webkit-scrollbar {
        display: none;
      }
    }
  
    .image-slot, .thumbnail-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      color: #909399;
      font-size: 20px;
    }
  }

  .rich-text-content {
    margin: 30px 0;
    line-height: 1.8;
    
    ::v-deep {
      img {
        max-width: 100%;
        height: auto;
        margin: 10px 0;
        border-radius: 4px;
      }

      table {
        width: 100% !important;
        margin: 15px 0;
        border-collapse: collapse;
        
        td, th {
          padding: 8px 12px;
          border: 1px solid #ebeef5;
        }
      }
    }
  }

  .attachment-list {
    h4 {
      margin: 0 0 15px 0;
      color: #606266;
      font-weight: normal;
    }

    .file-list {
      display: grid;
      gap: 12px;
    }

    .file-item {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      background: #f8f9fa;
      border-radius: 4px;
      transition: background 0.3s;

      &:hover {
        background: #f1f3f5;
      }

      .el-link {
        display: flex;
        align-items: center;
        
        i {
          margin-right: 8px;
          font-size: 16px;
        }
      }

      .file-tag {
        margin-left: 8px;
        height: 20px;
        line-height: 18px;
      }
    }
  }
}
</style>
